/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Booking_CalendarInputs */

const en_admin_dashboard_booking_calendar = /** @type {(inputs: Admin_Dashboard_Booking_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking Calendar`)
};

const de_admin_dashboard_booking_calendar = /** @type {(inputs: Admin_Dashboard_Booking_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungskalender`)
};

const es_admin_dashboard_booking_calendar = /** @type {(inputs: Admin_Dashboard_Booking_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendario de reservas`)
};

const fr_admin_dashboard_booking_calendar = /** @type {(inputs: Admin_Dashboard_Booking_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendrier de réservation`)
};

const nl_admin_dashboard_booking_calendar = /** @type {(inputs: Admin_Dashboard_Booking_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserveringskalender`)
};

const it_admin_dashboard_booking_calendar = /** @type {(inputs: Admin_Dashboard_Booking_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendario prenotazioni`)
};

const pt_br2_admin_dashboard_booking_calendar = /** @type {(inputs: Admin_Dashboard_Booking_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendário de reservas`)
};

const pl_admin_dashboard_booking_calendar = /** @type {(inputs: Admin_Dashboard_Booking_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalendarz rezerwacji`)
};

const hu_admin_dashboard_booking_calendar = /** @type {(inputs: Admin_Dashboard_Booking_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalási naptár`)
};

const ro_admin_dashboard_booking_calendar = /** @type {(inputs: Admin_Dashboard_Booking_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar Rezervari`)
};

/**
* | output |
* | --- |
* | "Booking Calendar" |
*
* @param {Admin_Dashboard_Booking_CalendarInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_booking_calendar = /** @type {((inputs?: Admin_Dashboard_Booking_CalendarInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Booking_CalendarInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_booking_calendar(inputs)
	if (locale === "de") return de_admin_dashboard_booking_calendar(inputs)
	if (locale === "es") return es_admin_dashboard_booking_calendar(inputs)
	if (locale === "fr") return fr_admin_dashboard_booking_calendar(inputs)
	if (locale === "nl") return nl_admin_dashboard_booking_calendar(inputs)
	if (locale === "it") return it_admin_dashboard_booking_calendar(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_booking_calendar(inputs)
	if (locale === "pl") return pl_admin_dashboard_booking_calendar(inputs)
	if (locale === "hu") return hu_admin_dashboard_booking_calendar(inputs)
	return ro_admin_dashboard_booking_calendar(inputs)
});
export { admin_dashboard_booking_calendar as "admin.dashboard.booking_calendar" }